import ComingSoon from '../../Components/ComingSoon';
function Settings() {
  return (
    <ComingSoon/>
  )
}

export default Settings